import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  template: `
    @if (value) {
      <div class="value">
        @if (link) {
          <a [routerLink]="link">{{ value }}</a>
        }
        @if (!link && action) {
          <a (click)="action()">{{ value }}</a>
        }
        @if (!link && !action) {
          {{ value }}
        }
      </div>
    }
    @if (!value) {
      <glxy-blank-value />
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextRendererComponent {
  value: string | undefined;
  link: string | undefined;
  action: (() => void) | undefined;
}
